import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_HeadFrame } from '../../../lib/data/standard-weight';
import { standardWeight_TailFrame } from '../../../lib/data/standard-weight';

const PulleyFrameForm = ({ onSaveStructure, onChangeWeightSummary, pulleyFrames, beltWidth, drives }) => {
    const [isShow, setIsShow] = useState(pulleyFrames?.length || false);
    const [tension, setTension] = useState();
    const [newPulleyFrame, setNewPulleyFrame] = useState(pulleyFrames || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory, setTypeCategory] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    const typeCategoryText = useRef({
        0: 'Head Frame',
        1: 'Tail Frame',
    });

    /*  처음 props로 넘어온 pulleyFrames를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    const initialpulleyFrame = useRef(pulleyFrames || []);

    const headFrameRef = useRef(standardWeight_HeadFrame.find((item) => item.beltWidth === parseInt(beltWidth)));
    const tailFrameRef = useRef(standardWeight_TailFrame.find((item) => item.beltWidth === parseInt(beltWidth)));

    /* Tension 가져오기 */
    useEffect(() => {
        if (!drives || !Object.keys(drives)) {
            return;
        }
        const minValue = drives.reduce((minValue, currentObject) => {
            return currentObject.slackSideTension?.load < minValue ? currentObject.slackSideTension?.load : minValue;
        }, drives[0]['slackSideTension']);
        const maxValue = drives.reduce((maxValue, currentObject) => {
            return currentObject.tightSideTension?.load > maxValue ? currentObject.tightSideTension?.load : maxValue;
        }, drives[0]['tightSideTension']);
        const _tension = typeCategory === '0' ? maxValue : minValue; // typeCategory가 Head면 maxValue, Tail이면 minValue

        setTension(Math.ceil((_tension?.load / 9800) * 10) / 10); // 소수점 1자리 ton 단위로 변환
    }, [drives, typeCategory]);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    useEffect(() => {
        if (!standardWeight_HeadFrame || !standardWeight_TailFrame || !beltWidth) {
            return;
        }

        const library = typeCategory === '0' ? headFrameRef.current : tailFrameRef.current;

        if (!library) {
            alert('Check Belt Width!');
            return;
        }

        let index;

        if (typeCategory === '0') {
            // Head면
            const T1 = tension;
            // console.log('T1 : ', T1);
            if (T1 <= 2.0) {
                index = 0;
            } else if (T1 <= 5.0) {
                index = 1;
            } else if (T1 <= 10) {
                index = 2;
            } else if (T1 <= 15) {
                index = 3;
            } else {
                index = 4;
            }
        } else {
            // Tail이면
            const T2 = tension;
            //   console.log('T2 : ', T2);
            if (T2 <= 1.4) {
                index = 0;
            } else if (T2 <= 2.3) {
                index = 1;
            } else if (T2 <= 3.6) {
                index = 2;
            } else if (T2 <= 4.5) {
                index = 3;
            } else if (T2 <= 5.7) {
                index = 4;
            } else if (T2 <= 7.2) {
                index = 5;
            } else {
                index = 6;
            }
        }

        const _standardWeight = library.standardWeight[index];
        setStandardWeight(_standardWeight);
    }, [beltWidth, tension, typeCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor) {
        //     return;
        // }
        const _weight = Math.ceil(standardWeight * factor);
        setUnitWeight(_weight);
    }, [factor, standardWeight]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!unitWeight || !qty) {
        //     return;
        // }
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newPulleyFrame.length) {
            return 0;
        }
        return Math.max(...newPulleyFrame.map((item) => Number(item.id.substring(3))), 0);
    }, [newPulleyFrame]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`PF-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newPulleyFrame에 pulleyFrame 추가 */
    const onAddPulleyFrame = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const pulleyFrame = {
            id,
            pulleyFrameType: typeCategoryText.current[typeCategory],
            tension,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewPulleyFrame((prev) => [...prev, pulleyFrame]);
        setIsChanged(true);
    }, [id, typeCategory, tension, standardWeight, factor, qty, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 pulleyFrame 삭제 */
    const onDeletePulleyFrame = useCallback((id) => {
        setNewPulleyFrame((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newPulleyFrame에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newPulleyFrame);
        getTotalWeight(newPulleyFrame);
        initializeForm();
        onSaveStructure({
            key: 'pulleyFrame',
            value: newPulleyFrame,
        });
        onChangeWeightSummary({
            key: 'pulleyFrame',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newPulleyFrame,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSavePulleyFrame = useCallback(() => {
    //     onSaveStructure({
    //         key: 'pulleyFrame',
    //         value: newPulleyFrame,
    //     });
    //     onChangeWeightSummary({
    //         key: 'pulleyFrame',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newPulleyFrame, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newPulleyFrame를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewPulleyFrame(initialpulleyFrame.current);
    //     onSaveStructure({
    //         key: 'pulleyFrame',
    //         value: initialpulleyFrame.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'pulleyFrame',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <PulleyFrameFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Pulley Frame</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type</th>
                                <th>
                                    Tension
                                    <br />
                                    (ton)
                                </th>
                                <th>
                                    Standard W't
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Factor</th>
                                <th>
                                    단위중량
                                    <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newPulleyFrame &&
                                newPulleyFrame.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.pulleyFrameType}</td>
                                        <td>{item.tension}</td>
                                        <td>{item.standardWeight}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeletePulleyFrame(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td className="td-radio">
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="0"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Head Pulley</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="1"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>Tail Pulley</span>
                                        </label>
                                    </div>
                                </td>
                                <td>{tension}</td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddPulleyFrame}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Pulley Frame Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSavePulleyFrame} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </PulleyFrameFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const PulleyFrameFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.5rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default PulleyFrameForm;
